// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BatchesDashboard\BatchesDashboardViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { RecurringBatch, RecurringBatchData, RecurringBatchOptions } from 'data/models/RecurringBatch';
import { PortCallUserRole } from 'server/enums/PortCallUserRole';

// BatchesDashboardData is the class that BatchesDashboard serializes to/from
export interface BatchesDashboardData {
    FromDate : /* ISO8601 */ string;
    OrganizationId : number;
    Role : PortCallUserRole;
    ToDate : /* ISO8601 */ string;
	
    Batches : RecurringBatchData[] | null;
    Organization : OrganizationData | null;
	
}

// BatchesDashboardOptions is the class which may be passed to the BatchesDashboard constructor to define optional initial data values
export interface BatchesDashboardOptions {
    FromDate : /* ISO8601 */ string;
    OrganizationId : number;
    Role : PortCallUserRole;
    ToDate : /* ISO8601 */ string;
	
    Batches? : RecurringBatchOptions[] | null;
    Organization? : OrganizationOptions | null;
	
}

export class BatchesDashboard {
    public FromDate : DataSignal<TZDate>;
    public OrganizationId : DataSignal<number>;
    public Role : DataSignal<PortCallUserRole>;
    public ToDate : DataSignal<TZDate>;
	
    public Batches : SDataArray<RecurringBatch>;
    public Organization : DataSignal<Organization | null>;
	

    constructor();
    constructor(data : BatchesDashboardOptions);
    constructor(data: BatchesDashboardOptions | null = null) {
        this.FromDate = jsonableObservable(S.value<TZDate>(data && data.FromDate !== undefined ? new TZDate(data.FromDate) : new TZDate(0), TZDate.eq));
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Role = jsonableObservable(S.value<PortCallUserRole>(data && data.Role !== undefined ? data.Role : 0));
        this.ToDate = jsonableObservable(S.value<TZDate>(data && data.ToDate !== undefined ? new TZDate(data.ToDate) : new TZDate(0), TZDate.eq));
	    
        this.Batches = SArray<RecurringBatch>([]);
        this.Organization = S.value<Organization | null>(null);
	    
    }

    static key(obj : BatchesDashboard) {
        return obj.FromDate().toJSON() + '\u2618' + obj.OrganizationId() + '\u2618' + obj.Role() + '\u2618' + obj.ToDate().toJSON();
    }
    
    static dataKey(obj : BatchesDashboardOptions) {
        return new TZDate(obj.FromDate).toJSON() + '\u2618' + obj.OrganizationId + '\u2618' + obj.Role + '\u2618' + new TZDate(obj.ToDate).toJSON();
    }

    static update(obj : BatchesDashboard, data : BatchesDashboardOptions) {
        S.freeze(() => {
            if (data.FromDate !== undefined) obj.FromDate(new TZDate(data.FromDate));
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
            if (data.Role !== undefined) obj.Role(data.Role);
            if (data.ToDate !== undefined) obj.ToDate(new TZDate(data.ToDate));
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BatchesDashboard.ts